export default __webpack_public_path__ + "static/ford-color-771bdf4eb96a8a7476ae4a345e458ad7.svg";